import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  getConversionFunnelReport,
  getTeamPerformanceReport,
  getReportPropertyList,
  getReportEmployeeList,
  getTeamCpPerformanceReport,
} from "reduxStore/action/reportActions";
import moment from "moment";
import { handleListResponse } from "utils/utils";
import { getMonthlyPropertyReport } from "../../reduxStore/action/reportActions";
import * as XLSX from "xlsx";
import TableDataNotFound from "component/TableDataNotFound";
import strings from "translate/language";
import { isEmpty, seo } from "utils/utils";
import * as FileSaver from "file-saver";
import Breadcrumb from "component/common/breadcrumb";
import Pagination from "component/common/Pagination";
import "./PdrReport.css";
import "./ReportListing.css";

const ReportDetail = ({ isAuth = false }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [pageOne, setPageOne] = useState(0);
  const [reportList, setReportList] = useState([]);
  const [teamReportList, setTeamReportList] = useState([]);
  const [teamcpReportList, setTeamCpReportList] = useState([]);
  const [siteReportPropertyList, setSiteReportPropertyList] = useState([]);
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const [form, setForm] = useState({
    employee: "",
    cpuser: "",
    site: "",
  });

  const ReportListSelector = useSelector((state) => state.report);

  useEffect(() => {
    seo({
      title: "Report Listing",
      metaDescription: "All Report list",
      canonicalLink: window.location.href,
    });
    let interval = setInterval(() => {
      filterDetail(true);
    }, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    let employee_id = isEmpty(form?.employee)
      ? isEmpty(form?.cpuser)
        ? ""
        : form?.cpuser?._id
      : form?.employee?._id;
    let params = {
      limit: 10,
      offset: newOffset,
      property_id: form?.site?._id,
      employee_id: employee_id,
    };

    dispatch(getTeamPerformanceReport(params));
  };
  const handlePageClickCp = (newOffset) => {
    setPageOne(newOffset);
    let employee_id = isEmpty(form?.employee)
      ? isEmpty(form?.cpuser)
        ? ""
        : form?.cpuser?._id
      : form?.employee?._id;
    let params = {
      limit: 10,
      offset: newOffset,
      property_id: form?.site?._id,
      employee_id: employee_id,
    };

    dispatch(getTeamCpPerformanceReport(params));
  };

  const filterDetail = (interval = false) => {
    let employee_id = isEmpty(form?.employee)
      ? isEmpty(form?.cpuser)
        ? ""
        : form?.cpuser?._id
      : form?.employee?._id;
    dispatch(
      getConversionFunnelReport({
        property_id: form?.site?._id,
        employee_id: employee_id,
        isLoadMore: interval,
      })
    );
    dispatch(
      getTeamPerformanceReport({
        limit: 10,
        offset: 0,
        property_id: form?.site?._id,
        employee_id: employee_id,
        isLoadMore: interval,
      })
    );
    dispatch(
      getTeamCpPerformanceReport({
        limit: 10,
        offset: 0,
        property_id: form?.site?._id,
        employee_id: employee_id,
        isLoadMore: interval,
      })
    );
    setPage(0);
  };

  const filterReset = () => {
    setForm({
      employee: "",
      cpuser: "",
      site: "",
    });
    dispatch(getConversionFunnelReport());
    dispatch(getTeamPerformanceReport({ limit: 10, offset: 0 }));
    dispatch(getTeamCpPerformanceReport({ limit: 10, offset: 0 }));
    setPage(0);
  };

  useEffect(() => {
    dispatch(getConversionFunnelReport());
    dispatch(getReportPropertyList({ limit: 10, offset: 0 }));
    dispatch(getReportEmployeeList({ limit: 10, offset: 0, user_type: 1 }));
    dispatch(getReportEmployeeList({ limit: 10, offset: 0, user_type: 2 }));
    dispatch(getTeamPerformanceReport({ limit: 10, offset: 0 }));
    dispatch(getTeamCpPerformanceReport({ limit: 10, offset: 0 }));
  }, [dispatch]);

  useEffect(() => {
    const {
      response,
      teamResponse,
      teamCpResponse,
      reportPropertyList,
      reportEmployeeList,
      reportCPNAMEList,
    } = ReportListSelector;
    if (response) {
      setReportList(response.data);
    } else {
      setReportList([]);
    }
    if (teamResponse) {
      setTeamReportList(teamResponse.data);
    } else {
      setTeamReportList([]);
    }
    if (teamCpResponse) {
      setTeamCpReportList(teamCpResponse.data);
    } else {
      setTeamCpReportList([]);
    }
    if (reportPropertyList) {
      setSiteReportPropertyList(reportPropertyList.data);
    } else {
      setSiteReportPropertyList([]);
    }
    if (reportEmployeeList) {
      setEmployeeList(reportEmployeeList.data);
    } else {
      setEmployeeList([]);
      // import React, { useEffect, useState } from "react";
      // import strings from "translate/language";
      // import { useDispatch, useSelector } from "react-redux";
      // import moment from "moment";
      // import { seo } from "utils/utils";
      // import Breadcrumb from "component/common/breadcrumb";
      // import {
      //   getMonthlyPropertyReport,
      //   getReportPropertyList,
      // } from "../../reduxStore/action/reportActions";
      // import { handleListResponse } from "utils/utils";
      // import Select from "react-select";
      // import * as XLSX from "xlsx";
      // import * as FileSaver from "file-saver";

      const ReportManage = ({ isAuth = false }) => {
        const dispatch = useDispatch();
        const [viewData, setViewData] = useState({});
        const [formVaild, setFormVaild] = useState({});
        const [propertyList, setPropertyList] = useState([]);
        const [endDateDisable, setEndDateDisable] = useState(true);
        const [isTotalUser, setisTotalUser] = useState(false);
        const [isActiveUser, setisActiveUser] = useState(false);
        const [isDectiveUser, setisDectiveUser] = useState(false);

        const toggleUserDropdown = () => {
          setisTotalUser(!isTotalUser);
          setisActiveUser(false);
          setisDectiveUser(false);
        };
        const toggleActiveUserDropdown = () => {
          setisActiveUser(!isActiveUser);
          setisTotalUser(false);
          setisDectiveUser(false);
        };
        const toggleDectiveUserDropdown = () => {
          setisDectiveUser(!isDectiveUser);
          setisTotalUser(false);
          setisActiveUser(false);
        };

        const monthlyPropertyReportSelector =
          useSelector((state) => state.report) || {};
        const ReportListSelector = useSelector((state) => state.report);

        const [form, setForm] = useState({
          start_date: "",
          end_date: "",
          property_id: "",
        });

        useEffect(() => {
          const { reportPropertyList } = ReportListSelector;
          if (reportPropertyList) {
            if (reportPropertyList?.status === 200) {
              setPropertyList(handleListResponse(reportPropertyList.data));
            } else {
              setPropertyList([]);
            }
          }
        }, [ReportListSelector]);

        useEffect(() => {
          if (monthlyPropertyReportSelector.monthlyPropertyReport) {
            const { monthlyPropertyReport } = monthlyPropertyReportSelector;
            if (monthlyPropertyReport?.status === 200) {
              setViewData(handleListResponse(monthlyPropertyReport?.data));
            }
          }
        }, [monthlyPropertyReportSelector]);

        useEffect(() => {
          dispatch(getMonthlyPropertyReport());
        }, []);

        const handleInputField = (e) => {
          const nextFormState = {
            ...form,
            [e.target.name]: e.target.value,
          };
          setForm(nextFormState);
          if (e.target.name === "end_date") {
            setFormVaild({
              ...formVaild,
              end_date: "",
            });
          }
        };

        const handleValid = () => {
          let err = { ...formVaild };
          let formError = false;
          if (form.start_date !== "") {
            if (form.end_date === "") {
              formError = true;
              err["end_date"] = strings.endDateErr;
            }
          }
          setFormVaild(err);
          return formError;
        };

        // Disable end_date
        useEffect(() => {
          if (form.start_date === "") {
            setEndDateDisable(true);
          } else {
            setEndDateDisable(false);
          }
        }, [form.start_date]);

        const filterDetail = () => {
          if (!handleValid()) {
            dispatch(
              getMonthlyPropertyReport({
                start_date: form.start_date,
                end_date: form.end_date,
                property_id: form?.site?._id,
              })
            );
          }
        };

        const filterReset = () => {
          setForm({
            start_date: "",
            end_date: "",
            property_id: "",
            site: "",
          });
          setFormVaild({
            ...formVaild,
            end_date: "",
          });
          dispatch(getMonthlyPropertyReport());
        };

        useEffect(() => {
          seo({
            title: "KPI Tracker Report",
            metaDescription: "Report management",
            canonicalLink: window.location.href,
          });
        }, []);

        const handleTotalCount = (prop) => {
          if (viewData?.length > 0) {
            return viewData?.reduce(function (a, b) {
              return a + b[prop];
            }, 0);
          }
        };

        //Download List data in excel file
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        const date = new Date();
        const todayDate = form.start_date
          ? moment(form.start_date).format("DD-MM-YYYY")
          : moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
              "DD-MM-YYYY"
            );
        const lastDate = form.end_date
          ? moment(form.end_date).format("DD-MM-YYYY")
          : moment(new Date()).format("DD-MM-YYYY");
        const fileName = "REPORT" + todayDate + "_to_" + lastDate;
        const exportticketdata = async (apiData) => {
          try {
            if (viewData?.length > 0) {
              var customHeadings = viewData?.map((item) => ({
                "Property Title": item.property_title,
                Status: item.status ? "Active" : "Deactive",
                "Visitors Entry": item.leadCount,
                "Site Visit Create": item.sitevisitCount,
                "Actual Visit ": item.sitevisitcheckinCount,
                "No Show Visit": item.sitevisitnoshowCount,
                Revisit: item.revisitCount,
                "Customer Lost": item.sitevisitlostCount,
                "Booking Done": item.bookingCount,
                "Booking Cancel": item.cancelbookingCount,
                "New CP Registered": item.CpCount,
                "Total Maped CP": item.totalcpregister,
                "Total Employees": item.userCount,
                "Active Employees": item.AtiveuserCount,
                "Deactive Employees": item.InAtiveuserCount,
              }));
            } else {
            }
          } catch (e) {}

          const ws = XLSX.utils.json_to_sheet(customHeadings);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, fileName + fileExtension);
        };

        return (
          <div className="page-body">
            {isAuth && (
              <Breadcrumb
                title={strings.report}
                parentListing={null}
                titleactive={strings.kpiTrackerList}
              />
            )}
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12 col-xl-12">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-body">
                          <form className="theme-form">
                            <div className="row">
                              <div className="col-md-4">
                                <span className="cardText">
                                  {strings.startDate}
                                </span>
                                <div
                                  className="input-group date"
                                  id="dt-date"
                                  data-target-input="nearest"
                                >
                                  <input
                                    className="form-control datetimepicker-input digits"
                                    type="date"
                                    data-target="#dt-date"
                                    name="start_date"
                                    value={form.start_date}
                                    onChange={handleInputField}
                                    min={form.start_date}
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <span className="cardText">
                                  {strings.endDate}
                                </span>
                                <div
                                  className="input-group date"
                                  id="dt-date"
                                  data-target-input="nearest"
                                >
                                  <input
                                    className="form-control datetimepicker-input digits"
                                    type="date"
                                    name="end_date"
                                    value={form.end_date}
                                    onChange={handleInputField}
                                    min={form.start_date}
                                    disabled={endDateDisable}
                                  />
                                </div>
                                {formVaild.end_date && (
                                  <span style={{ color: "red" }}>
                                    {formVaild.end_date}
                                  </span>
                                )}
                              </div>
                              <div className="col-md-4">
                                <span className="cardText">
                                  {strings.searchByPropertyName}
                                </span>
                                <Select
                                  isSearchable
                                  isClearable
                                  onInputChange={(e) => {
                                    if (e.length > 1) {
                                      dispatch(
                                        getReportPropertyList({
                                          search_site: e,
                                          isLoadMore: true,
                                        })
                                      );
                                    } else {
                                      dispatch(
                                        getReportPropertyList({
                                          limit: 10,
                                          offset: 0,
                                          isLoadMore: true,
                                        })
                                      );
                                    }
                                  }}
                                  placeholder={strings.searchByPropertyName}
                                  options={propertyList}
                                  getOptionLabel={(option) =>
                                    `${option.property_title}`
                                  }
                                  getOptionValue={(option) => option._id}
                                  name="site"
                                  value={form.site}
                                  onChange={(e) => {
                                    setForm({ ...form, site: e });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="row pt-3">
                              <div className="col-md-12 pt-4">
                                <div className="form-group d-flex justify-content-end">
                                  <button
                                    className="btn btn-warning mr-4"
                                    type="button"
                                    onClick={filterDetail}
                                  >
                                    {strings.search}
                                  </button>
                                  <button
                                    className="btn btn-dark"
                                    type="button"
                                    onClick={filterReset}
                                  >
                                    {strings.reset}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card" style={{ border: "1px solid #a1a1a1" }}>
                    <div key={1} className="card-body">
                      <div className="row pb-1">
                        <div className="col-md-8 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                            }}
                          >
                            {strings.totalCountForall}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="row pt-0 col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalVisitorsEntry}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("leadCount")}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0  col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalSiteVisitCreate}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("sitevisitCount")}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0  col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalActualVisit}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("sitevisitcheckinCount")}
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <div className="row pt-0">
                        <div className="row pt-0 col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalNoshowvisit}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("sitevisitnoshowCount")}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0  col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalRevisit}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("revisitCount")}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0  col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalCustomerLost}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("sitevisitlostCount")}
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="row pt-0 col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalBookingDone}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("bookingCount")}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0  col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalReportBookingCancel}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("cancelbookingCount")}
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row pt-0  col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalNewCPRegisteredFTM}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("CpCount")}
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <div className="row pt-0">
                        <div className="row pt-0 col-md-4">
                          <div className="col-md-8 align-items-center">
                            <label htmlFor="exampleInputMobileNo">
                              {strings.TotalCPMapRegisteredtillDate}
                            </label>
                          </div>
                          <div className="col-md-4 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {handleTotalCount("totalcpregister")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="d-flex row justify-content-end pb-3">
                        <div className="col-md-2">
                          <button
                            className="btn btn-warning mr-4"
                            type="button"
                            onClick={() => exportticketdata({}, "Report")}
                          >
                            {strings.exportList}
                          </button>
                        </div>
                      </div>
                      <div>
                        {viewData?.length > 0
                          ? viewData.map((item, index) => {
                              return (
                                <div
                                  className="card"
                                  style={{ border: "1px solid #a1a1a1" }}
                                >
                                  <div key={index} className="card-body">
                                    <div className="row pb-1">
                                      <div className="col-md-8 align-items-center">
                                        <label
                                          htmlFor="exampleInputMobileNo"
                                          style={{
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {item.property_title}
                                        </label>
                                      </div>
                                      <div className="col-md-4">
                                        <label
                                          htmlFor="exampleInputMobileNo"
                                          style={{
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            float: "right",
                                          }}
                                        >
                                          {strings.status}
                                          {" : "}
                                          <span
                                            style={{
                                              color: item.status
                                                ? "green"
                                                : "red",
                                            }}
                                          >
                                            {item.status
                                              ? "Active"
                                              : "Deactive"}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="row pt-0">
                                      <div className="row pt-0 col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.VisitorsEntry}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.leadCount
                                              ? item.leadCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.SiteVisitCreate}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.sitevisitCount
                                              ? item.sitevisitCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.ActualVisit}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.sitevisitcheckinCount
                                              ? item.sitevisitcheckinCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="row pt-0">
                                      <div className="row pt-0 col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.Noshowvisit}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.sitevisitnoshowCount
                                              ? item.sitevisitnoshowCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.Revisit}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.revisitCount
                                              ? item.revisitCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.CustomerLost}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.sitevisitlostCount
                                              ? item.sitevisitlostCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="row pt-0">
                                      <div className="row pt-0 col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.BookingDone}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.bookingCount
                                              ? item.bookingCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.ReportBookingCancel}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.cancelbookingCount
                                              ? item.cancelbookingCount
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.NewCPRegisteredFTM}
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.CpCount ? item.CpCount : 0}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="row pt-0">
                                      <div className="row pt-0 col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {
                                              strings.TotalCPMapRegisteredtillDate
                                            }
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.totalcpregister
                                              ? item.totalcpregister
                                              : 0}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="row pt-0">
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.totalUser} :
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.userCount
                                              ? item.userCount
                                              : 0}{" "}
                                            {item?.userCount > 0 && (
                                              <i
                                                class="fa fa-caret-down"
                                                aria-hidden="true"
                                                onClick={toggleUserDropdown}
                                                style={{
                                                  cursor: "pointer",
                                                  fontSize: "18px",
                                                }}
                                                title="Click and view total user"
                                              />
                                            )}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0  col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.activeEmp} :
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.AtiveuserCount
                                              ? item.AtiveuserCount
                                              : 0}{" "}
                                            {item?.AtiveuserCount > 0 && (
                                              <i
                                                class="fa fa-caret-down"
                                                aria-hidden="true"
                                                onClick={
                                                  toggleActiveUserDropdown
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  fontSize: "18px",
                                                }}
                                                title="Click and view active user"
                                              />
                                            )}
                                          </label>
                                        </div>
                                      </div>
                                      <hr />
                                      <div className="row pt-0 col-md-4">
                                        <div className="col-md-8 align-items-center">
                                          <label htmlFor="exampleInputMobileNo">
                                            {strings.deactiveEmp} :
                                          </label>
                                        </div>
                                        <div className="col-md-4 align-items-center">
                                          <label
                                            htmlFor="exampleInputMobileNo"
                                            className="boldText"
                                          >
                                            {item.InAtiveuserCount
                                              ? item.InAtiveuserCount
                                              : 0}{" "}
                                            {item?.InAtiveuserCount > 0 && (
                                              <i
                                                class="fa fa-caret-down"
                                                aria-hidden="true"
                                                onClick={
                                                  toggleDectiveUserDropdown
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  fontSize: "18px",
                                                }}
                                                title="Click and view deactive user"
                                              />
                                            )}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    {/* <hr className="className-1" /> */}
                                    <div className="row">
                                      <div className="col-md-12">
                                        {isTotalUser && (
                                          <div className="dropdown-content">
                                            <div className="row">
                                              <div className="col-sm-12">
                                                <div className="card">
                                                  <div className="card-header">
                                                    <h5>
                                                      {strings.listTotalUser}
                                                    </h5>
                                                  </div>
                                                  <div className="table-responsive">
                                                    <table className="table table-border-horizontal">
                                                      <thead className="text-center">
                                                        <tr>
                                                          <th scope="col">
                                                            {strings.name}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.email}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.mobileNo}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.lastLogin}
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody className="text-center">
                                                        {item?.userInfo
                                                          ?.length > 0 ? (
                                                          item?.userInfo?.map(
                                                            (itm, idx) => {
                                                              return (
                                                                <tr key={idx}>
                                                                  <td>
                                                                    {itm.user_name
                                                                      ? itm.user_name
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {itm.email
                                                                      ? itm.email
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {itm.mobile
                                                                      ? itm.mobile
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {moment
                                                                      .utc(
                                                                        itm.last_login
                                                                      )
                                                                      .format(
                                                                        "DD-MM-yyyy hh:mm a"
                                                                      )}
                                                                  </td>
                                                                </tr>
                                                              );
                                                            }
                                                          )
                                                        ) : (
                                                          <tr />
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        {isActiveUser && (
                                          <div className="dropdown-content">
                                            <div className="row">
                                              <div className="col-sm-12">
                                                <div className="card">
                                                  <div className="card-header">
                                                    <h5>
                                                      {strings.listActiveUser}
                                                    </h5>
                                                  </div>
                                                  <div className="table-responsive">
                                                    <table className="table table-border-horizontal">
                                                      <thead className="text-center">
                                                        <tr>
                                                          <th scope="col">
                                                            {strings.name}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.email}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.mobileNo}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.lastLogin}
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody className="text-center">
                                                        {item?.AtiveuserInfo
                                                          ?.length > 0 ? (
                                                          item?.AtiveuserInfo?.map(
                                                            (itm, idx) => {
                                                              return (
                                                                <tr key={idx}>
                                                                  <td>
                                                                    {itm.user_name
                                                                      ? itm.user_name
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {itm.email
                                                                      ? itm.email
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {itm.mobile
                                                                      ? itm.mobile
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {moment
                                                                      .utc(
                                                                        itm.last_login
                                                                      )
                                                                      .format(
                                                                        "DD-MM-yyyy hh:mm a"
                                                                      )}
                                                                  </td>
                                                                </tr>
                                                              );
                                                            }
                                                          )
                                                        ) : (
                                                          <tr />
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        {isDectiveUser && (
                                          <div className="dropdown-content">
                                            <div className="row">
                                              <div className="col-sm-12">
                                                <div className="card">
                                                  <div className="card-header">
                                                    <h5>
                                                      {strings.listDectiveUser}
                                                    </h5>
                                                  </div>
                                                  <div className="table-responsive">
                                                    <table className="table table-border-horizontal">
                                                      <thead className="text-center">
                                                        <tr>
                                                          <th scope="col">
                                                            {strings.name}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.email}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.mobileNo}
                                                          </th>
                                                          <th scope="col">
                                                            {strings.lastLogin}
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody className="text-center">
                                                        {item?.InAtiveuserInfo
                                                          ?.length > 0 ? (
                                                          item?.InAtiveuserInfo?.map(
                                                            (itm, idx) => {
                                                              return (
                                                                <tr key={idx}>
                                                                  <td>
                                                                    {itm.user_name
                                                                      ? itm.user_name
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {itm.email
                                                                      ? itm.email
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {itm.mobile
                                                                      ? itm.mobile
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {moment
                                                                      .utc(
                                                                        itm.last_login
                                                                      )
                                                                      .format(
                                                                        "DD-MM-yyyy hh:mm a"
                                                                      )}
                                                                  </td>
                                                                </tr>
                                                              );
                                                            }
                                                          )
                                                        ) : (
                                                          <tr />
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : strings.notavailable}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      };
      // export default ReportManage;
    }
    if (reportCPNAMEList) {
      setchannelPartnerList(reportCPNAMEList.data);
    } else {
      setchannelPartnerList([]);
    }
  }, [ReportListSelector]);

  const selectMenuPortalProps = {
    menuPortalTarget:
      typeof document !== "undefined" ? document.body : null,
    menuPosition: "fixed",
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    },
  };

  return (
    <div className="page-body justo-report-page justo-report-listing-page">
      {isAuth && (
        <Breadcrumb
          title={strings.report}
          parentListing={null}
          titleactive={strings.report}
        />
      )}
      <div className="justo-report">
        <div className="justo-report__card">
          <div className="justo-report__top">
            <div>
              <h1 className="justo-report__title">{strings.report}</h1>
              <p className="justo-report__subtitle">
                {isAuth
                  ? "Conversion funnel, follow-up status, lead quality, and team performance by site, employee, or channel partner."
                  : strings.report}
              </p>
            </div>
          </div>

          <form
            className="justo-report__filters"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="justo-report__filters-grid">
              <label className="justo-report__field">
                <span className="justo-report__label">{strings.bySite}</span>
                <Select
                  classNamePrefix="justo-report-select"
                  isSearchable
                  isClearable
                  {...selectMenuPortalProps}
                  onInputChange={(e) => {
                    if (e.length > 1) {
                      dispatch(
                        getReportPropertyList({
                          search_site: e,
                          isLoadMore: true,
                        })
                      );
                    } else {
                      dispatch(
                        getReportPropertyList({
                          limit: 10,
                          offset: 0,
                          isLoadMore: true,
                        })
                      );
                    }
                  }}
                  placeholder={strings.selectSite}
                  options={siteReportPropertyList}
                  getOptionLabel={(option) => `${option.property_title}`}
                  getOptionValue={(option) => option._id}
                  name="site"
                  value={form.site}
                  onChange={(e) => {
                    setForm({
                      ...form,
                      site: e,
                      employee: null,
                      cpuser: null,
                    });
                    if (e && e._id) {
                      dispatch(
                        getReportEmployeeList({
                          limit: 10,
                          offset: 0,
                          user_type: 1,
                          property_id: e._id,
                        })
                      );
                      dispatch(
                        getReportEmployeeList({
                          limit: 10,
                          offset: 0,
                          user_type: 2,
                          property_id: e._id,
                        })
                      );
                    }
                  }}
                />
              </label>
              <label className="justo-report__field">
                <span className="justo-report__label">{strings.byEmployee}</span>
                <Select
                  classNamePrefix="justo-report-select"
                  isSearchable
                  isClearable
                  isDisabled={isEmpty(form.cpuser) ? false : true}
                  {...selectMenuPortalProps}
                  onInputChange={(e) => {
                    if (e.length > 1) {
                      dispatch(
                        getReportEmployeeList({
                          user_name: e,
                          isLoadMore: true,
                          user_type: 1,
                          property_id: form?.site?._id,
                        })
                      );
                    } else {
                      dispatch(
                        getReportEmployeeList({
                          limit: 10,
                          offset: 0,
                          isLoadMore: true,
                          user_type: 1,
                          property_id: form?.site?._id,
                        })
                      );
                    }
                  }}
                  placeholder={strings.SelectEmployee}
                  options={employeeList}
                  getOptionLabel={(option) => `${option.user_name}`}
                  getOptionValue={(option) => option.user_id}
                  name="employee"
                  value={form.employee}
                  onChange={(e) => {
                    setForm({ ...form, employee: e, cpuser: null });
                  }}
                />
              </label>
              <label className="justo-report__field">
                <span className="justo-report__label">{strings.byCPName}</span>
                <Select
                  classNamePrefix="justo-report-select"
                  isSearchable
                  isClearable
                  isDisabled={isEmpty(form.employee) ? false : true}
                  {...selectMenuPortalProps}
                  onInputChange={(e) => {
                    if (e.length > 1) {
                      dispatch(
                        getReportEmployeeList({
                          user_name: e,
                          isLoadMore: true,
                          user_type: 2,
                          property_id: form?.site?._id,
                        })
                      );
                    } else {
                      dispatch(
                        getReportEmployeeList({
                          limit: 10,
                          offset: 0,
                          isLoadMore: true,
                          user_type: 2,
                          property_id: form?.site?._id,
                        })
                      );
                    }
                  }}
                  placeholder={strings.selectCPName}
                  options={getchannelPartnerList}
                  getOptionLabel={(option) => `${option.user_name}`}
                  getOptionValue={(option) => option._id}
                  name="cpuser"
                  value={form.cpuser}
                  onChange={(e) => {
                    setForm({ ...form, cpuser: e, employee: null });
                  }}
                />
              </label>
            </div>
            <div className="justo-report__filter-footer">
              <div className="justo-report__filter-actions">
                <button
                  type="button"
                  className="justo-report__btn justo-report__btn--solid"
                  onClick={() => filterDetail(false)}
                >
                  {strings.search}
                </button>
                <button
                  type="button"
                  className="justo-report__btn justo-report__btn--ghost"
                  onClick={filterReset}
                >
                  {strings.reset}
                </button>
              </div>
            </div>
          </form>

          <div className="justo-report__body">
            <div className="justo-report__sections">
              <section className="justo-report__section">
                <h2 className="justo-report__section-title">
                  {strings.conversionFunnel}
                </h2>
                <div className="justo-report__table-wrap">
                  <table className="justo-report__table">
                    <thead>
                      <tr>
                        <th scope="col">{strings.parameters}</th>
                        <th scope="col">{strings.today}</th>
                        <th scope="col">{strings.LastSevenDays}</th>
                        <th scope="col">{strings.LastThirtyDays}</th>
                        <th scope="col">{strings.mtd}</th>
                        <th scope="col">{strings.Ytd}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportList?.conversion_funnel?.length ? (
                        reportList.conversion_funnel.map((item, index) => (
                          <tr key={index}>
                            <td>{item.title}</td>
                            <td>{item.today}</td>
                            <td>{item.seven_day}</td>
                            <td>{item.last_thirty_day}</td>
                            <td>{item.mtd}</td>
                            <td>{item.ytd}</td>
                          </tr>
                        ))
                      ) : (
                        <tr />
                      )}
                    </tbody>
                  </table>
                  <TableDataNotFound data={reportList?.conversion_funnel} />
                </div>
              </section>

              <section className="justo-report__section">
                <h2 className="justo-report__section-title">
                  {strings.followupStatus}
                </h2>
                <div className="justo-report__table-wrap">
                  <table className="justo-report__table">
                    <thead>
                      <tr>
                        <th scope="col">{strings.status}</th>
                        <th scope="col">{strings.today}</th>
                        <th scope="col">{strings.LastSevenDays}</th>
                        <th scope="col">{strings.LastThirtyDays}</th>
                        <th scope="col">{strings.mtd}</th>
                        <th scope="col">{strings.Ytd}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportList?.followup_status?.length ? (
                        reportList.followup_status.map((item, index) => (
                          <tr key={index}>
                            <td>{item.title}</td>
                            <td>{item.today}</td>
                            <td>{item.seven_day}</td>
                            <td>{item.last_thirty_day}</td>
                            <td>{item.mtd}</td>
                            <td>{item.ytd}</td>
                          </tr>
                        ))
                      ) : (
                        <tr />
                      )}
                    </tbody>
                  </table>
                  <TableDataNotFound data={reportList?.followup_status} />
                </div>
              </section>

              <section className="justo-report__section">
                <h2 className="justo-report__section-title">
                  {strings.LeadQuality}
                </h2>
                <div className="justo-report__table-wrap">
                  <table className="justo-report__table">
                    <thead>
                      <tr>
                        <th scope="col">{strings.status}</th>
                        <th scope="col">{strings.fifty}</th>
                        <th scope="col">{strings.fifityseventy}</th>
                        <th scope="col">{strings.seventyplus}</th>
                        <th scope="col">{strings.total}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportList?.lead_quality?.length ? (
                        reportList.lead_quality.map((item, index) => (
                          <tr key={index}>
                            <td>{item.title}</td>
                            <td>{item.fifty}</td>
                            <td>{item.fifty_to_seventy}</td>
                            <td>{item.seventy}</td>
                            <td>{item.total ? item.total : "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr />
                      )}
                    </tbody>
                  </table>
                  <TableDataNotFound data={reportList?.lead_quality} />
                </div>
              </section>

              {isEmpty(form.cpuser) ? (
                <section className="justo-report__section">
                  <h2 className="justo-report__section-title">
                    {strings.teamPerformance}
                  </h2>
                  <div className="justo-report__table-wrap">
                    <table className="justo-report__table">
                      <thead>
                        <tr>
                          <th scope="col">{strings.department}</th>
                          <th scope="col">{strings.teamMemberName}</th>
                          <th scope="col">{strings.lead}</th>
                          <th scope="col">{strings.visitorsActual}</th>
                          <th scope="col">{strings.bookingsActual}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {teamReportList?.length ? (
                          teamReportList.map((item, index) => (
                            <tr key={index}>
                              <td>{item.role_title}</td>
                              <td>{item.user_name}</td>
                              <td>{item.total_visit}</td>
                              <td>{item.total_site_visit}</td>
                              <td>{item.total_booking_visit}</td>
                            </tr>
                          ))
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={teamReportList} />
                  </div>
                  <div className="justo-report__section-pagination">
                    <Pagination
                      totalCount={
                        ReportListSelector?.teamResponse?.total_data
                      }
                      listData={teamReportList}
                      onPageChange={handlePageClick}
                      itemOffset={page}
                      setItemOffset={setPage}
                    />
                  </div>
                </section>
              ) : null}

              {isEmpty(form.employee) ? (
                <section className="justo-report__section">
                  <h2 className="justo-report__section-title">
                    {strings.teamCPPerformance}
                  </h2>
                  <div className="justo-report__table-wrap">
                    <table className="justo-report__table">
                      <thead>
                        <tr>
                          <th scope="col">{strings.agencyName}</th>
                          <th scope="col">{strings.cpName}</th>
                          <th scope="col">{strings.lead}</th>
                          <th scope="col">{strings.visitorsActual}</th>
                          <th scope="col">{strings.bookingsActual}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {teamcpReportList?.length ? (
                          teamcpReportList.map((item, index) => (
                            <tr key={index}>
                              <td>{item.agency_name}</td>
                              <td>{item.user_name}</td>
                              <td>{item.total_visit}</td>
                              <td>{item.total_site_visit}</td>
                              <td>{item.total_booking_visit}</td>
                            </tr>
                          ))
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={teamcpReportList} />
                  </div>
                  <div className="justo-report__section-pagination">
                    <Pagination
                      totalCount={
                        ReportListSelector?.teamCpResponse?.total_data
                      }
                      listData={teamcpReportList}
                      onPageChange={handlePageClickCp}
                      itemOffset={pageOne}
                      setItemOffset={setPageOne}
                    />
                  </div>
                </section>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReportDetail;
